import { css } from "@emotion/css";
import { LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { GetTeamsLookupBffResponseTeam, TagSetResource, UserResource, ApprovalPolicyResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { UserChip } from "~/components/Chips/UserChip";
import { ChipIcon, TeamChip } from "~/components/Chips/index";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import LookupResourceChip from "~/components/LookupResourceChip/index";
import InternalLink from "~/components/Navigation/InternalLink/index";
import Tag from "~/components/Tag/index";
interface ApprovalPolicyTableProps {
    approvalPolicies: ApprovalPolicyResource[];
    projectTagSets: TagSetResource[];
    environmentTagSets: TagSetResource[];
    teamsLookup: GetTeamsLookupBffResponseTeam[];
    usersLookup: UserResource[];
}
export function ApprovalPolicyTable({ approvalPolicies, teamsLookup, usersLookup, projectTagSets, environmentTagSets }: ApprovalPolicyTableProps) {
    const LookupTeamChip = LookupResourceChip<GetTeamsLookupBffResponseTeam>();
    const projectTagsLookup = projectTagSets.flatMap((tagSet) => tagSet.Tags);
    const environmentTagsLookup = environmentTagSets.flatMap((tagSet) => tagSet.Tags);
    return (<LegacyDataTable>
            <LegacyDataTableHeader>
                <LegacyDataTableRow>
                    <LegacyDataTableHeaderColumn width={"30%"} aria-label={"Name column"}>
                        Name
                    </LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn aria-label={"Approvers column"} width={"25%"}>
                        Approvers
                    </LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn aria-label={"Approvals Required column"} width={"5%"}>
                        Approvals Required
                    </LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn aria-label={"Project Tags column"}>Project Tags</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn aria-label={"Environment Tags column"}>Environment Tags</LegacyDataTableHeaderColumn>
                </LegacyDataTableRow>
            </LegacyDataTableHeader>
            <LegacyDataTableBody>
                {approvalPolicies.map((policy) => (<LegacyDataTableRow key={policy.Id}>
                        <LegacyDataTableRowColumn className={styles.nameColumn}>
                            <InternalLink to={links.approvalPolicyPage.generateUrl({ spaceId: policy.SpaceId, id: policy.Id })}>{policy.Name}</InternalLink>
                        </LegacyDataTableRowColumn>
                        <LegacyDataTableRowColumn>
                            {policy.ApprovingTeamIds && policy.ApprovingTeamIds.map((team) => <LookupTeamChip lookupCollection={teamsLookup} key={team} lookupId={team} type={ChipIcon.Team} chipRender={(t) => <TeamChip team={t}/>}/>)}
                            {policy.ApprovingUserIds &&
                policy.ApprovingUserIds.map((user) => {
                    const userInfo = usersLookup.find((u) => u.Id === user);
                    return userInfo && <UserChip user={userInfo}></UserChip>;
                })}
                        </LegacyDataTableRowColumn>
                        <LegacyDataTableRowColumn>{policy.MinimumApproversRequired}</LegacyDataTableRowColumn>
                        <LegacyDataTableRowColumn>
                            <div>
                                {isFeatureToggleEnabled("extended-tag-sets") &&
                policy.ProjectTags &&
                policy.ProjectTags.map((tag) => {
                    const tagInfo = projectTagsLookup.find((t) => t.CanonicalTagName === tag);
                    return tagInfo && <Tag key={tag} tagName={tagInfo.CanonicalTagName} description={tagInfo.Description} tagColor={tagInfo.Color} small={false}/>;
                })}
                            </div>
                        </LegacyDataTableRowColumn>
                        <LegacyDataTableRowColumn>
                            <div>
                                {isFeatureToggleEnabled("extended-tag-sets") &&
                policy.EnvironmentTags &&
                policy.EnvironmentTags.map((tag) => {
                    const tagInfo = environmentTagsLookup.find((t) => t.CanonicalTagName === tag);
                    return tagInfo && <Tag key={tag} tagName={tagInfo.CanonicalTagName} description={tagInfo.Description} tagColor={tagInfo.Color} small={false}/>;
                })}
                            </div>
                        </LegacyDataTableRowColumn>
                    </LegacyDataTableRow>))}
            </LegacyDataTableBody>
        </LegacyDataTable>);
}
const styles = {
    nameColumn: css({
        wordWrap: "break-word",
    }),
};
